import axios, { AxiosInstance } from 'axios';
import { logoutDispatcher } from '../store/auth';
import { errorNotification } from './mantine-notifications';

let store: {
  getState: any;
  dispatch: any;
};

export const injectStore = (_store: any) => {
  store = _store;
};

function addInterceptors(instance: AxiosInstance) {
  instance.interceptors.request.use((config) => {
    const token = store?.getState()?.auth?.token;
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error.response?.status;

      if (status === 401) {
        const message = (error.response?.data as any)?.message as
          | string
          | undefined;
        const isTokenError =
          !message ||
          message === 'Unauthorized' ||
          message.includes('jwt') ||
          message.includes('token') ||
          message.includes('expirado') ||
          message.includes('expired');

        if (isTokenError) {
          store.dispatch(logoutDispatcher());
        }
        return Promise.reject(error);
      }

      if (status === 403) {
        errorNotification({
          id: 'forbidden-error',
          title: 'Acesso negado',
          message: 'Você não tem permissão para realizar esta ação.',
        });
        return Promise.reject(error);
      }

      if (status === 429) {
        errorNotification({
          id: 'rate-limit-error',
          title: 'Muitas requisições',
          message: 'Aguarde alguns instantes e tente novamente.',
        });
        return Promise.reject(error);
      }

      if (!status || status >= 500) {
        errorNotification({
          id: 'server-error',
          title: 'Erro no servidor',
          message: 'Ocorreu um erro inesperado. Tente novamente em instantes.',
        });
        return Promise.reject(error);
      }

      return Promise.reject(error);
    },
  );
}

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

addInterceptors(api);

export const stockApi = axios.create({
  baseURL: process.env.REACT_APP_STOCK_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

addInterceptors(stockApi);

export const financialApi = axios.create({
  baseURL: process.env.REACT_APP_FINANCIAL_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

addInterceptors(financialApi);
